import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';

const schedules = [
  {
    day: 'Domingos',
    name: 'Culto de Celebração',
    description: 'Um tempo em família para celebrar a Jesus com louvor, comunhão e palavra.',
    times: ['10h', '17h', '19h30'],
    accent: 'border-yellow-500',
    badge: 'bg-yellow-500/10 text-yellow-400 border-yellow-500/20',
  },
  {
    day: 'Segunda-feira',
    name: 'Culto HOPE',
    description: 'Um clamor por esperança, cura e renovo espiritual para começar a semana.',
    times: ['20h00'],
    accent: 'border-blue-400',
    badge: 'bg-blue-500/10 text-blue-400 border-blue-500/20',
  },
  {
    day: 'Quarta-feira',
    name: 'Culto FÉ',
    description: 'Ensino profundo da Palavra para fortalecer sua caminhada cristã.',
    times: ['20h00'],
    accent: 'border-yellow-500',
    badge: 'bg-yellow-500/10 text-yellow-400 border-yellow-500/20',
  },
];

const ServiceSchedule = () => {
  return (
    <section id="schedules" className="py-24 bg-[#0a0f1e]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        <div className="text-center mb-16">
          <div className="section-label mx-auto w-fit">Programação</div>
          <h2 className="text-3xl md:text-4xl font-extrabold text-white tracking-tight">
            Nossos <span className="text-gradient">Cultos</span>
          </h2>
          <p className="text-gray-500 mt-3">Venha celebrar conosco e fortalecer sua fé</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {schedules.map((item, index) => (
            <div
              key={index}
              className={`glass-card card-shine rounded-2xl p-7 border-t-4 ${item.accent} flex flex-col group hover:bg-white/5 transition-all duration-300 hover:-translate-y-1`}
            >
              <div className="flex-grow">
                <span className={`inline-block text-xs font-bold uppercase tracking-widest border rounded-full px-3 py-1 mb-4 ${item.badge}`}>
                  {item.day}
                </span>
                <h4 className="text-xl font-bold text-white mb-3">{item.name}</h4>
                <p className="text-gray-500 text-sm leading-relaxed italic">
                  "{item.description}"
                </p>
              </div>

              <div className="mt-6 pt-5 border-t border-white/5">
                <div className="flex items-center gap-1.5 text-gray-500 text-xs mb-3">
                  <FontAwesomeIcon icon={faClock} className="text-yellow-500/70" />
                  Horários
                </div>
                <div className="flex flex-wrap gap-2">
                  {item.times.map((time) => (
                    <span
                      key={time}
                      className="bg-white/5 text-gray-200 border border-white/8 px-3 py-1 rounded-lg text-sm font-bold"
                    >
                      {time}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        <p className="text-center text-gray-600 mt-10 text-sm flex items-center justify-center gap-2">
          <FontAwesomeIcon icon={faMapMarkerAlt} className="text-yellow-500/60" />
          Av. Dep. Gastão Mariz de Faria, Cidade Verde — Parnamirim · RN
        </p>
      </div>
    </section>
  );
};

export default ServiceSchedule;
